export default __webpack_public_path__ + "static/media/kinerja.458a322c.png";